import React from "react";
import "../../style/Draggable.css";

const Draggable = () => {
  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Draggable
      </h1>

      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="nav-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-home"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
          >
            Simple
          </button>

          <button
            className="nav-link"
            id="nav-profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-profile"
            type="button"
            role="tab"
            aria-selected="false"
            tabIndex="-1"
          >
            Axis Restricted
          </button>

          <button
            className="nav-link"
            id="nav-drag-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-drag"
            type="button"
            role="tab"
            aria-selected="false"
            tabIndex="-1"
          >
            Container Restricted
          </button>
        </div>
      </nav>

      <div className="tab-content" id="nav-tabContent">

        {/* SIMPLE */}
        <div
          className="tab-pane fade mt-3 show active"
          id="nav-home"
          role="tabpanel"
        >
          <div id="draggables" className="drag-box">
            <p>Drag me around</p>
          </div>
        </div>

        {/* AXIS RESTRICTED */}
        <div className="tab-pane fade mt-3" id="nav-profile" role="tabpanel">
          <div id="div_element" className="drag-axis">
            Drag X Axis
          </div>

          <div id="div_elementy" className="drag-axis">
            Drag Y Axis
          </div>
        </div>

        {/* CONTAINER RESTRICTED */}
        <div className="tab-pane fade mt-3" id="nav-drag" role="tabpanel">
          <div id="parentContainer">
            <div id="intro" className="drag-limit">
              You can drag this element. However,
              it now has a <strong>limit</strong>.
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Draggable;